import { HangulJamo } from "../../types/hangul";

// https://en.wikipedia.org/wiki/Yale_romanization_of_Korean
export const YALE: HangulJamo = {
  // https://en.wikipedia.org/wiki/Yale_romanization_of_Korean#Consonants
  "ᄀ": {
    base: "k",
  },
  "ᄁ": {
    base: "kk",
  },
  "ᄂ": {
    base: "n",
  },
  "ᄃ": {
    base: "t",
  },
  "ᄄ": {
    base: "tt",
  },
  "ᄅ": {
    base: "l",
  },
  "ᄆ": {
    base: "m",
  },
  "ᄇ": {
    base: "p",
  },
  "ᄈ": {
    base: "pp",
  },
  "ᄉ": {
    base: "s",
  },
  "ᄊ": {
    base: "ss",
  },
  "ᄋ": {
    base: "",
  },
  "ᄌ": {
    base: "c",
  },
  "ᄍ": {
    base: "cc",
  },
  "ᄎ": {
    base: "ch",
  },
  "ᄏ": {
    base: "kh",
  },
  "ᄐ": {
    base: "th",
  },
  "ᄑ": {
    base: "ph",
  },
  "ᄒ": {
    base: "h",
  },
  // https://en.wikipedia.org/wiki/Yale_romanization_of_Korean#Vowels
  "ᅡ": {
    base: "a",
  },
  "ᅢ": {
    base: "ay",
  },
  "ᅣ": {
    base: "ya",
  },
  "ᅤ": {
    base: "yay",
  },
  "ᅥ": {
    base: "e",
  },
  "ᅦ": {
    base: "ey",
  },
  "ᅧ": {
    base: "ye",
  },
  "ᅨ": {
    base: "yey",
  },
  "ᅩ": {
    base: "o",
  },
  "ᅪ": {
    base: "wa"
  },
  "ᅫ": {
    base: "way"
  },
  "ᅬ": {
    base: "oy"
  },
  "ᅭ": {
    base: "yo"
  },
  "ᅮ": {
    base: "u"
  },
  "ᅯ": {
    base: "we"
  },
  "ᅰ": {
    base: "wey"
  },
  "ᅱ": {
    base: "wi"
  },
  "ᅲ": {
    base: "yu"
  },
  "ᅳ": {
    base: "u"
  },
  "ᅴ": {
    base: "uy"
  },
  "ᅵ": {
    base: "i"
  },
  // https://en.wikipedia.org/wiki/Yale_romanization_of_Korean#Consonants
  "": {
    base: "",
  },
  "ᆨ": {
    base: "k",
  },
  "ᆩ": {
    base: "kk",
  },
  "ᆪ": {
    base: "ks",
  },
  "ᆫ": {
    base: "n",
  },
  "ᆬ": {
    base: "nc",
  },
  "ᆭ": {
    base: "nh",
  },
  "ᆮ": {
    base: "t",
  },
  "ᆯ": {
    base: "l",
  },
  "ᆰ": {
    base: "lkh",
  },
  "ᆱ": {
    base: "lm",
  },
  "ᆲ": {
    base: "lph",
  },
  "ᆳ": {
    base: "ls",
  },
  "ᆴ": {
    base: "lth",
  },
  "ᆵ": {
    base: "lph",
  },
  "ᆶ": {
    base: "lh",
  },
  "ᆷ": {
    base: "m",
  },
  "ᆸ": {
    base: "p",
  },
  "ᆹ": {
    base: "ps",
  },
  "ᆺ": {
    base: "s",
  },
  "ᆻ": {
    base: "ss",
  },
  "ᆼ": {
    base: "ng",
  },
  "ᆽ": {
    base: "c",
  },
  "ᆾ": {
    base: "ch",
  },
  "ᆿ": {
    base: "kh",
  },
  "ᇀ": {
    base: "th",
  },
  "ᇁ": {
    base: "ph",
  },
  "ᇂ": {
    base: "h",
  },
}